import React, { useEffect } from "react";
import CardDescription from "./Components/CardDescription";
import Header from "./Components/Header";
import Offers from "./Components/Offers";
import RecciveOffer from "./Components/RecciveOffer";
import { useClup } from "./Hooks";
import Loading from "../../Common/Loading";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
function Index({ isApp }) {
  const { user, user_type } = useSelector(state => state);
  const { getclup, Data, buyoffer } = useClup();
  useEffect(() => {
    getclup();
  }, []);
  const Bottn = [
    {
      name: "نیک کلاب",
      link: "#offers",
    },
    {
      name: "تخفیف های دریافتی",
      link: "#recive",
    },
    {
      name: "توضیحات",
      link: "#desc",
    },
  ];
  return (
    <>
      <Helmet>
        <title>نیک کلاب | نیکوتن</title>
        <meta name="description" content={"نیک کلاب"} />
        <link rel="canonical" href={window.origin + `/clup}`} />
      </Helmet>
      <div className="container-lg">
        {Data.loading ? (
          <Loading count={1} col={12} height={400} />
        ) : (
          <>
            {!isApp && <Header data={Data.data.bannerclup} />}
            {!isApp && <div className="row justify-content-evenly    my-5 ">
              {Bottn.map((btn, key) => {
                if (user_type) {
                  return (
                    <div
                      key={key}
                      className="col d-flex justify-content-center"
                    >
                      <a href={btn.link}>
                        <div className="tab-click">{btn.name}</div>
                      </a>
                    </div>
                  );
                } else {
                  if (btn.link != "#recive")
                    return (
                      <div
                        key={key}
                        className="col d-flex justify-content-center"
                      >
                        <a href={btn.link}>
                          <div className="tab-click">{btn.name}</div>
                        </a>
                      </div>
                    );
                }
              })}
            </div>
            }
            <div id="offers">
              <Offers isApp={isApp} data={Data.data.offers} buyoffer={buyoffer} />
            </div>
            {user_type && (
              <div id="recive">
                <RecciveOffer isApp={isApp} data={Data.data.useroffer} />
              </div>
            )}
            <div id="desc" className="mb-4">
              <CardDescription isApp={isApp} data={Data.data.description} />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Index;
